<template>
  <div class="contenedorContenido">
    <h1>Home</h1>
    <p></p>
    <div class="d-flex flex-row">
      <articulo
        v-for="item in articulos"
        :key="item.Id"
        v-bind:articulo="item"
        v-bind:src_carro="src_carro"
        v-bind:src_lupa="src_lupa"
      />
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { bus } from "../main.js";
import BotonSeccion from "./BotonSeccion.vue";
import Servicios from "../services.js";
import Articulo from "./Articulo.vue";
// Components
//import ListadoArticulos from './Listado_Articulos.vue'

export default {
  components: { Articulo },
  data() {
    return {
      src_carro: "dist/img/icon-carro.png",
      src_lupa: "dist/img/icon-lupa.png",
      articulos: [],
    };
  },
  computed: {
    secciones() {
      return this.$store.state.secciones;
    },
  },  
  methods: {
    async obtenerArticulosPortada() {
      var vm = this;
      let articulos = await Servicios.ObtenerArticulosPortada();
      vm.articulos = articulos;
    },
  },
  async created() {
    console.log("MOUNTED");
    await this.obtenerArticulosPortada();
  },
};
</script>
